<template>
    <Modal :visible.sync="openModal">
        <main class="lengthSetting-main">
            <div class="lengthSetting-close">
                <img src="@/assets/image/lengthSetting/icon4.png" @click.stop="close" class="cursor_1" width="18"
                    height="18" />
            </div>
            <div class="lengthSetting-list">
                <div class="lengthSetting-item" v-for="(item, index) in list" :key="index"
                    :class="item.selected ? 'selected' : ''"  @click.stop="itemClick(item)">
                    <div class="lengthSetting-item_left">
                        <p class="ls_title1">
                            <span :class="'color' + (index + 1)">{{ item.title }}</span>
                            <span :class="'color' + (index + 1)">{{ item.split }}​​</span>
                        </p>
                        <Steps class="t-m-t-23 t-m-b-10" :steps="item.steps" />
                    </div>
                    <div class="lengthSetting-item_right">
                        <img v-if="!item.title.includes('中')" :src="item.img" width="240" height="143"
                            class="t-m-r-40" />
                        <img v-else :src="item.img" width="108" height="109"
                            style="margin-right: 90px;margin-top: 20px;" />
                    </div>
                    <div class="lengthSetting-item_top_right">
                        <img :src="item.labelImg" width="91" height="38" />
                    </div>
                    <div class="lengthSetting-item_bottom_right" v-if="item.selected">
                        <img :src="item.selectImg" width="41.5" height="28.4" />
                    </div>
                </div>
            </div>
        </main>
    </Modal>
</template>

<script>
import lNApi from '@/api/longNovel';
import Modal from '@/components/Modal.vue';
import Steps from '@/components/long_novel/steps.vue'
export default {
    components: {
        Modal, Steps
    },
    data() {
        return {
            lableShow: false, //标签选择弹框显示
            list: [
                // {
                //     title: '短篇小说',
                //     split: '4万字内 快速成型 适合练手 征文',
                //     steps: [
                //         { title: '步骤: 填写作品信息>生成大纲>生成章节细纲>生成正文' },
                //         { title: '完结后，可续写成长篇' },
                //         { title: '适合:番茄小说平台、知乎平台发布' }
                //     ],
                //     img: require('@/assets/image/lengthSetting/icon2.png'),
                //     labelImg: require('@/assets/image/lengthSetting/icon6.png'),
                //     selectImg: require('@/assets/image/lengthSetting/icon7.png'),
                //     length: '短篇小说',
                //     selected: false
                // },
                // {
                //     title: '中长篇小说​​',
                //     split: '4-30万字 适合新人',
                //     steps: [
                //         { title: '步骤: 填写作品信息>生成大纲>生成章节细纲>生成正文' },
                //         { title: '完结后，可续写成长篇' },
                //         { title: '适合：番茄小说、飞卢、书旗、七猫、起点、知乎平台' }
                //     ],
                //     img: require('@/assets/image/lengthSetting/icon10.png'),
                //     labelImg: require('@/assets/image/lengthSetting/icon9.png'),
                //     selectImg: require('@/assets/image/lengthSetting/icon7.png'),
                //     length: '中长篇小说​​',
                //     selected: false
                // },
                // {
                //     title: '长篇小说',
                //     split: '30万字以上 适合有经验的作家',
                //     steps: [
                //         { title: '步骤: 填写作品信息>生成分卷>生成分卷大纲>生成 章节细纲>生成正文' },
                //         { title: '完结后，可续写成大长篇' },
                //         { title: '适合：番茄小说、飞卢、书旗、七猫、起点、知乎平台' }
                //     ],
                //     img: require('@/assets/image/lengthSetting/icon3.png'),
                //     labelImg: require('@/assets/image/lengthSetting/icon1.png'),
                //     selectImg: require('@/assets/image/lengthSetting/icon7.png'),
                //     length: '长篇小说',
                //     selected: false
                // }
            ],
            openModal: false,//通用弹窗显示关闭控制器
            type:'',//add,copy，edit代表选择篇幅的行为
            novelId:null,//小说id
        }
    },
    created(){
          
    },
    methods: {
        open(type='',novelId='') {
            this.getLengSettingList()
            this.type = type
            this.novelId = novelId
            this.openModal = true
        },
        close() {
            this.openModal = false
            this.$emit('close')
        },
        getLengSettingList() {
            lNApi.longNovelDown().then(res=>{
                if(res.code === 200){
                    this.list = res.data.map(item=>({
                        steps:item.description.split('\n').map(text=>({title:text.replace(/&gt;/g, '>')})),
                        selected:false,
                        length: item.title,
                        title:item.title,
                        selectImg: item.title.includes('短')? require('@/assets/image/lengthSetting/icon7.png') : item.title.includes('中') ? require('@/assets/image/lengthSetting/icon7.png') : require('@/assets/image/lengthSetting/icon7.png'),
                        labelImg: item.title.includes('短')? require('@/assets/image/lengthSetting/icon6.png') : item.title.includes('中') ? require('@/assets/image/lengthSetting/icon9.png') : require('@/assets/image/lengthSetting/icon1.png'),
                        img: item.title.includes('短')? require('@/assets/image/lengthSetting/icon2.png') : item.title.includes('中') ? require('@/assets/image/lengthSetting/icon10.png') : require('@/assets/image/lengthSetting/icon3.png'),
                        split:item.subTitle,
                        tag:item.tag,
                    }))
                }
            })
        },
        handleClose() {
            this.close()
        },
        itemClick(item){
            this.list = this.list.filter(m=>{
                if(item.title === m.title){
                    m.selected = true
                }else{
                    m.selected = false
                }
                return m
            })
            this.$emit('curClick',{item:item,type:this.type,novelId:this.novelId})
        }
    }
}
</script>

<style lang="scss" scoped>
p {
    margin: 0;
}

img {
    display: block;
}

.lengthSetting-main {
    background: url('@/assets/image/lengthSetting/bg.png') no-repeat;
    background-size: cover;
    min-height: 678px;
    padding: 0 0 20px;
    width: 902px;
    z-index: -1;
}

.lengthSetting-close {
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 21px;
}

.lengthSetting-list {
    padding: 0 21px;

    .lengthSetting-item {
        position: relative;
        background: url('@/assets/image/lengthSetting/icon5.png') no-repeat;
        background-size: cover;
        width: 860px;
        min-height: 178px;
        display: flex;
        margin-bottom: 28px;
        border-radius: 20px;

        &:last-child {
            margin-bottom: 0;
        }

        &:hover {
            outline: 2px solid red;
            cursor: pointer;
        }

        &.selected {
            outline: 2px solid red;
        }
    }

    .ls_title1 {
        margin-top: 26px;

        .color1 {
            color: #FE6C00;
        }

        .color2 {
            color: #FE0083;
        }

        .color3 {
            color: #9500FE;
        }

        span:first-child {
            font-size: 26px;
            font-weight: bold;
            margin-right: 10px;
        }

        span:nth-child(n+2) {
            font-size: 16px;
            // color: #888888;
        }
    }

    .lengthSetting-item_left {
        flex: 1;
        margin-left: 45px;
        display: flex;
        flex-direction: column;
    }

    .lengthSetting-item_right {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .lengthSetting-item_top_right {
        position: absolute;
        right: 0px;
        top: 0;
    }

    .lengthSetting-item_bottom_right {
        position: absolute;
        right: 0;
        bottom: 0;
    }
}
</style>